import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const StyledModal = styled(Modal)`
  .modal-dialog {
    top: 8%;
  }
  .modal-content {
    width: 400px;
    padding: 24px;
    border-radius: 12px;
    margin:0 auto;
  }
  .modal-body {
    padding: 0px;
  }
`;

export const CalendarHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  color: #184A61;
  font-family: 'Lato';
  font-size: 18px;
  font-weight: 700;

  .left-content {
    display: flex;
    align-items: center;
  }

  .close-icon {
    cursor: pointer;
    text-align: right;
  }
`;

export const Border = styled.div`
  border: 1px solid #EFEFEF;
`;

export const CalendarWrapper = styled.div`
  padding: 16px 0;
`;

export const ConfirmVisitText = styled.div`
  font-family: 'Lato';
  font-size: 16px;
  color: #184A61;
  text-align: center;
  
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const TourButton = styled.button`
  min-width: 150px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato';
  padding: 12px 16px;
  font-size: 16px;
  border: ${({ primary }) => primary ? 'none' : '1px solid #da6c74'};
  background: ${({ primary }) => primary ? '#DA6C74' : 'transparent'};
  color: ${({ primary }) => primary ? '#fff' : '#184A61'};
  cursor: pointer;
  border-radius: 6px;
  font-weight: 500;
  
  &:hover {
    background: ${({ primary }) => primary ? '#C85B63' : '#F8F8F8'};
  }
`;
export const SubText = styled.div`
  font-family: 'Lato';
  font-size: 14px;
  color: #CE7841;
  text-align: center;
  margin-top: 16px;
  font-weight: 400;
`;
